<template>
    <div>
        <div id="page" class="haslist">
             <Header></Header>
        <!--<div class="w-tab">
            <ul>
                <li v-for="(item, index) in articleType" :class="{on: activeType === index}" @click="changeType(index)">
                    <span><router-link :to="">{{ item.typename }}</router-link></span>
                </li>
            </ul>
        </div>-->
        <div class="m-text">
            <div class="text-hd">
                <h1>{{ info.title }}</h1>
                <div class="info">
                    <span>{{ info.re_create_time }}</span>
                    <span>来源：{{ info.article_source }}</span>
                    <span>作者：{{ info.author }}</span>
                    <div class="keep" v-if="info.iscollect == 0" @click="keep"></div>
                    <div class="keep on" v-else-if="info.iscollect == 1" @click="unKeep"></div>
                    <div class="share" @click="showTip = true"></div>
                </div>
            </div>
            <div class="text-bd" v-html="info.content"></div>
            <div class="text-ft">
                <div class="tags">
                    <span v-for="sub in info.label_name"><router-link :to="{path: 'searchResult', query: {key: sub}}">{{ sub }}</router-link></span>
                </div>
            </div>
        </div>

        </div>
       
        <Footer></Footer>
        <div class="share-tip" v-show="showTip" @click="showTip = false">
            <img src="../assets/images/share-tip.png" alt="">
        </div>
    </div>
</template>

<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import {Toast} from 'vant'
    import wx from 'weixin-js-sdk'

    export default {
        name: "DetailInfoView",
        data: function () {
            return {
                showTip: false,
                type: this.$route.query.type,
                id: '',
                articleType: [],
                activeType: 0,
                info: {},
            }
        },
        components: {
            Header, Footer,
            [Toast.name]: Toast
        },
        mounted: function () {
            this.id = this.$route.query.id;
            this.getInfo();
        },
        methods: {
            changeType (index) {
                this.activeType = index;
                this.getList();
            },
            getInfo() {
                const _this = this;
                _this.api.getArticleView({info_id: _this.id}).then(function (response) {
                    _this.info = response.article_info;
                    _this.info.re_create_time = _this.formatTime(_this.info.create_time, '{y}-{m}-{d}');
                    _this.getShareConfig();
                })
            },
            keep(){
                const _this = this;
                let params = new FormData();
                params.append('id', _this.info.info_id);
                params.append('type', 'info');
                _this.api.addCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getInfo();
                })
            },
            unKeep(){
                const _this = this;
                let params = new FormData();
                params.append('collection_id', _this.info.collection_id);
                _this.api.delCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getInfo();
                })
            },
            getShareConfig(){
                const _this = this;
                _this.api.getShareConfig({
                    url: window.location.href.split('#')[0],
                    target: 'DetailInfoView',
                    id: _this.$route.query.id
                }).then(function(response){
                    const result = response;
                    wx.config({
                        debug: false,
                        appId: result.appId,
                        timestamp: result.timestamp,
                        nonceStr: result.nonceStr,
                        signature: result.signature,
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'onMenuShareAppMessage',//老版本分享接口。
	                        'onMenuShareTimeline'//老版本分享
                        ]
                    });
                    var link = '';
                    var u = navigator.userAgent, app = navigator.appVersion;
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isAndroid) {
                        link = window.location.href.split('#')[0] + '?#' + window.location.href.split('#')[1]
                    }
                    if (isIOS) {
                        link = window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1]
                    }
                    wx.error(function (res) {
                        console.log('验证失败返回的信息:',res.errMsg);
                    });
                   
                    wx.ready(function () {
                        //const imgUrl = 'http://www.xuanzhizhongguo.com' + _this.info.thumbnail;
                        const imgUrl='https://www.xuanzhizhongguo.com/images/logo_share.png'
                        // 分享给朋友
                        wx.updateAppMessageShareData({
                            title: _this.info.title+'-选址中国', // 分享标题
                            desc: _this.info.description, // 分享描述
                            link: link,
                            imgUrl: imgUrl,
                            // imgUrl: 'http://www.xuanzhizhongguo.com/uploads/avatar/15577990642478.jpg', // 分享图标
                            success: function () {
                                console.log(wx)
                            }
                        });

                        // 分享到朋友圈
                        wx.updateTimelineShareData({
                           title: _this.info.title+'-选址中国', // 分享标题
                            desc: _this.info.description, // 分享描述
                            link: link,
                            imgUrl,
                            success: function () {
                                
                            }
                        });
                    });
                })
            }
        }
    }
</script>

<style scoped>
    .m-text {
        background-color: #fff;
        margin: .3rem;padding: .2rem;
    }

    .m-text h1 {
        font-size: .36rem;font-weight: bold;color: #1f1f1f;line-height: 1.2;padding: .4em 0;margin-bottom: .1rem;
    }

    .text-hd .info {position: relative;font-size: .24rem;margin-bottom: .2rem;line-height: .3rem;display: flex;justify-content: start;}
    .text-hd .info span {margin: 0 .1rem;}
    .text-bd {
        padding: .2rem 0;font-size: .28rem !important;color: #000 !important;line-height: 1.5 !important;overflow: hidden;
    }
    .text-hd .info .share {position: absolute;top: 0;right: .5rem;width: .3rem;height: .3rem;background: url("../assets/images/icon-share.png") no-repeat center center;-webkit-background-size: contain;background-size: contain;}
    .text-hd .info .keep {position: absolute;top: 0;right: 0;width: .3rem;height: .3rem;background: url("../assets/images/icon-keep.png") no-repeat center center;background-size: contain;}
    .text-hd .info .keep.on {background-image: url('../assets/images/icon-keep-on.png');}
    .text-ft {overflow: hidden;}

    .text-ft .info {float: right;line-height: .3rem;margin-left: .1rem;font-size: .18rem;}

    .tags {overflow: hidden;}

    .tags span {display:flex;align-items:center;justify-content:center;float: left;border: 1px solid #898989;margin-right: .1rem;font-size: .18rem;height: .4rem;color: #838383;padding: 0 .1rem;}
</style>
